<script lang="ts" setup>
import BaseTag from './BaseTag.vue';

defineProps<{
  name?: string;
}>();
</script>

<template>
  <BaseTag
    rounded-8
    bg-purple-500
  >
    {{ name }}
    <slot />
  </BaseTag>
</template>
